/* eslint-disable */
function mibsPopulateDetails( el ) {
	// TODO: Hide empty table columns
	// Start/End Date/Time
	jQuery( '.c-mibs-event-details__event-start' ).html( el.data( 'eventstart' ) );
	jQuery( '.c-mibs-event-details__event-end' ).html( el.data( 'eventend' ) );
	// Update quote form
	jQuery( 'input[name="event_start"]' ).val( el.data( 'eventstart' ) );
	jQuery( 'input[name="event_end"]' ).val( el.data( 'eventend' ) );
	// Location, hide if not set
	if ( el.data( 'eventlocation' ) ) {
		jQuery( '.c-mibs__location-data' ).removeClass( 'hidden' );
	} else {
		jQuery( '.c-mibs__location-data' ).addClass( 'hidden' );
	}
	// Location
	jQuery( '.c-mibs-event-details__event-location' ).html( el.data( 'eventlocation' ) );
	// Coach/Consultant, hide if not set
	if ( el.data( 'eventcoach' ) ) {
		jQuery( '.c-mibs__coach-data' ).removeClass( 'hidden' );
	} else {
		jQuery( '.c-mibs__coach-data' ).addClass( 'hidden' );
	}
	jQuery( '.c-mibs-event-details__event-coach' ).html( el.data( 'eventcoach' ) );
	// Price
	jQuery( '.c-mibs-event-details__price' ).html( el.data( 'eventprice' ) );
}

function mibsUpdateSummary() {
	const quantity   = jQuery( '.em-tickets-spaces select' ).val();
	const eventPrice = jQuery( '#mibs-selector' ).find( ":selected" ).data( 'eventprice' );
	const subTotal   = eventPrice * quantity;
	const vat        = jQuery( '.c-mibs__vat' ).data( 'mibsvat' );
	const vatFormat  = '0.' + vat;
	const vatCalc    = Math.round( ( subTotal * vatFormat ) * 100 ) / 100;
	const total      = Math.round( ( subTotal + vatCalc ) * 100 ) / 100;

	// TODO: Format price?
	// const lang = window.document.documentElement.lang;
	// parseFloat( subTotal ).toLocaleString( lang );

	jQuery( '.c-mibs__subtotal span' ).html( subTotal );
	jQuery( '.c-mibs__vat span' ).html( vatCalc );
	jQuery( '.c-mibs__total span' ).html( total );
}

function mibsToggleAnchorText( event ) {
	const $clickedBtn = jQuery( event.target ).data( 'bs.collapse' ).$trigger;

	$clickedBtn.find( '.u-toggle-show' ).toggleClass( 'hidden' );
	$clickedBtn.find( '.u-toggle-hide' ).toggleClass( 'hidden' );
}

function mibsSyncSelectOptions( select ) {
	let maxSpaces    = 20;
	const $select    = jQuery( select );
	const fullText   = $select.data( 'fulltext' );
	const spacesLeft = $select.find( ':selected' ).data( 'spacesleft' );

	// Clear options
	const $selects = jQuery( '#mibsQuantitySelect, .em-tickets-spaces select' );
	$selects.html( '' );

	// Reset toggle
	jQuery( 'button[data-target="#mibsBookingForm"]' ).prop( 'disabled', false );

	// Never show more options than there are spaces left
	if ( spacesLeft < maxSpaces ) {
		maxSpaces = spacesLeft;
		if ( 0 >= spacesLeft ) {
			$selects.append( '<option disabled selected value="1">' + fullText + '</option>' );
			// Hide booking form
			jQuery( '#mibsBookingForm' ).collapse( 'hide' );
			// Disable booking form toggle
			jQuery( 'button[data-target="#mibsBookingForm"]' ).prop( 'disabled', true );
		}
	}

	let i;
	for ( i = 0; i < maxSpaces; i++ ) {
		const num = i + 1;
		$selects.append( '<option value="' + num + '">' + num + '</option>' );
	}

	mibsUpdateSummary();

}

jQuery( function( $ ) {
	// Ugly JQuery example on how to change the event details in the form on date select
	$( '#mibs-selector' ).change( function() {
		if ( '' === this.value ) {
			return;
		}

		let eventID  = this.value;
		let ticketID = $( this ).find( ":selected" ).data( 'ticketid' );
		let dates    = $( this ).find( ":selected" ).data( 'eventdates' );

		// Get the number of tickets from another field and update the hidden field in the form
		let quantity = $( '#mibsQuantitySelect' ).val();
		$( '.em-tickets-spaces select' ).val( quantity );

		// Update id and name fields
		$( '.em-tickets-spaces select' ).attr( 'id', 'em-ticket-spaces-' + ticketID );
		$( '.em-tickets-spaces select' ).attr( 'name', 'em_tickets[' + ticketID + '][spaces]' );
		$( 'input[name="event_id"]' ).val( eventID );

		mibsPopulateDetails( $( this ).find( ":selected" ) );
		mibsUpdateSummary();

		// Show event details
		$( '#eventDetailsWrap' ).collapse( 'show' );

		// TODO: Set maximum number of options
		mibsSyncSelectOptions( this );

		// Check if there are additional dates
		if ( 0 < dates.length ) {
			// Show toggle buttons
			$( '.c-mibs__additional-dates-wrap' ).removeClass( 'hidden' );
		} else {
			// Hide toggle buttons and reset collapses
			$( '.c-mibs__additional-dates-wrap' ).addClass( 'hidden' );
			$( '#datesCollapseMobile' ).collapse( 'hide' );
			$( '#datesCollapseDesktop' ).collapse( 'hide' );
		}

		$( '.c-mibs__additional-dates' ).html( dates );
	});

	// Sync quantity
	$( '#mibsQuantitySelect' ).change( function() {
		$( '.em-tickets-spaces select' ).val( this.value );
		mibsUpdateSummary();
	});

	const bookingForm  = document.getElementById( "mibsBookingForm" );
	const quoteForm    = document.getElementById( "mibsQuoteForm" );
	const eventDetails = document.getElementById( "eventDetailsWrap" );

	// Handle form visibility and scroll behavior
	$( '#eventDetailsWrap' ).on( 'show.bs.collapse', function() {
		$( '#mibsQuoteForm' ).collapse( 'hide' );
	});
	$( '#eventDetailsWrap' ).on( 'shown.bs.collapse', function() {
		eventDetails.scrollIntoView({ behavior: "smooth" });
	});

	$( '#mibsBookingForm' ).on( 'shown.bs.collapse', function() {
		$( '#mibsQuoteForm' ).collapse( 'hide' );
		//console.log( 'Scroll to booking form' );
		bookingForm.scrollIntoView({ behavior: "smooth" });
	});

	$( '#mibsQuoteForm' ).on( 'show.bs.collapse', function() {
		$( '#mibsBookingForm' ).collapse( 'hide' );
	});

	$( '#mibsQuoteForm' ).on( 'shown.bs.collapse', function() {
		//console.log( 'Scroll to quote' );
		quoteForm.scrollIntoView({ behavior: "smooth" });
	});

	// Update toggle anchor texts
	$( '#datesCollapseDesktop, #datesCollapseMobile' ).on( 'hidden.bs.collapse', function ( e ) {
		mibsToggleAnchorText( e );
	});
	$( '#datesCollapseDesktop, #datesCollapseMobile' ).on( 'shown.bs.collapse', function ( e ) {
		mibsToggleAnchorText( e );
	});

});
